'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../index-0e40e0c2.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var components_Button_DeprecatedButton = require('../Button/DeprecatedButton.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var styles_breakpoints = require('../../breakpoints-7bb24b2d.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var styled = require('styled-components');
require('../../extends-f8003900.js');
require('../../objectWithoutProperties-aa43106a.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../NuDSProvider/NuDSProvider.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../theme-340a6118.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../defineProperty-3cad0327.js');
require('../../xstyled-prop-types.es-56667676.js');
require('../../utils/isType/isType.js');
require('../../withIntlAriaAttrs-7e974861.js');
require('../../utils/ref/refType.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var fadeIn = styled.keyframes(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    bottom: 0;\n  }\n\n  75% {\n    opacity: 1;\n  }\n"])));
var Container = xstyledStyledComponents_es.styled.div(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  padding: 1rem;\n  width: 100%;\n  max-width: calc(100% - 3rem);\n  background-color: ", ";\n  z-index: 99;\n\n  position: fixed;\n  left: auto;\n  right: 1.5rem;\n  bottom: 1.5rem;\n\n  animation: 0.3s ", " ease-in-out;\n\n  ", ";\n"])), styles_themeUtils.nuDSColor('black', 'light'), fadeIn, styles_breakpoints.tablet768(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    max-width: 420px;\n  "]))));
Container.displayName = 'Container';
var Content = xstyledStyledComponents_es.styled.div(_templateObject4 || (_templateObject4 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n"])));
Content.displayName = 'Content';
var Action = xstyledStyledComponents_es.styled.div(_templateObject5 || (_templateObject5 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  padding-left: 1.5rem;\n"])));
Action.displayName = 'Action';

function Snackbar(_ref) {
  var actionText = _ref.actionText,
      children = _ref.children,
      visible = _ref.visible,
      onActionClick = _ref.onActionClick;

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(Container, {
    role: "alert"
  }, /*#__PURE__*/React__default['default'].createElement(Content, null, /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], {
    color: "white.default",
    variant: "paragraph2",
    strong: true
  }, children)), /*#__PURE__*/React__default['default'].createElement(Action, null, /*#__PURE__*/React__default['default'].createElement(components_Button_DeprecatedButton['default'], {
    onClick: onActionClick,
    typographyVariant: "paragraph2"
  }, actionText)));
}

Snackbar.defaultProps = {
  actionText: 'Close',
  children: undefined,
  onActionClick: undefined,
  visible: false
};
Snackbar.propTypes = {
  actionText: index.PropTypes.node,
  children: index.PropTypes.node,
  onActionClick: index.PropTypes.func,
  visible: index.PropTypes.bool
};

exports.default = Snackbar;
//# sourceMappingURL=Snackbar.js.map
